module.exports = __webpack_public_path__ + "static/media/1.4b6120c4.jpg";